/* Les Femmes Célèbres — page d'accueil */

(function () {
  'use strict'; if (window.__lfcHomeOk) return; window.__lfcHomeOk = true;

  var IMG = window.LFC_IMAGE_BASE || '';   // défini dans calendrier-data.js
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
              'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var JOURS_PAR_MOIS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var DATA = window.LFC || [];

  function pad(n) { return String(n).padStart(2, '0'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function find(m, j) {
    var k = pad(m) + '-' + pad(j);
    for (var i = 0; i < DATA.length; i++) if (DATA[i].k === k) return DATA[i];
    return null;
  }
  function lien(e) { return '/blogs/' + (window.LFC_BLOG || 'calendrier-des-femmes-celebres') + '/' + e.h; }

  var LOGO = IMG + '6689_logomark-rond-348x348px.jpg';

  function portrait(e, cls) {
    if (!e.i) {
      return '<figure class="' + cls + ' ' + cls + '--none lfc-card__fig--none">' +
             '<img src="' + LOGO + '" alt="Portrait à venir" loading="lazy"></figure>';
    }
    return '<figure class="' + cls + '"><img src="' + IMG + encodeURIComponent(e.i) +
           '" alt="Portrait de ' + esc(e.n) + '" loading="lazy"></figure>';
  }

  /* ---------- recherche par date de naissance ---------- */

  var form = document.getElementById('finder');
  var out = document.getElementById('result');
  var HAS_FINDER = !!(form && out);

  function remplirSelects() {
    for (var d = 1; d <= 31; d++) form.jour.add(new Option(d, d));
    MOIS.forEach(function (m, i) { form.mois.add(new Option(m, i + 1)); });
  }

  function ajusterJours() {
    var m = parseInt(form.mois.value, 10);
    if (!m) return;
    var max = JOURS_PAR_MOIS[m - 1];
    var courant = parseInt(form.jour.value, 10);
    Array.prototype.forEach.call(form.jour.options, function (o) {
      if (o.value) o.hidden = parseInt(o.value, 10) > max;
    });
    if (courant > max) form.jour.value = '';
  }

  function afficher(e, mois, jour) {
    if (!e) {
      out.innerHTML = '<p class="lfc-result__none">Aucune fiche pour le ' + jour + ' ' +
                      MOIS[mois - 1] + ' pour le moment.</p>';
      return;
    }
    // une carte par femme née ce jour-là (la première, puis celles ajoutées à la suite)
    function carte(w) {
      var tags = '';
      if (w.p) {
        w.p.split(' · ').forEach(function (t) { tags += '<li>' + esc(t) + '</li>'; });
      }
      if (w.c) tags += '<li class="is-country">' + esc(w.c) + '</li>';
      return '<article class="lfc-card">' + portrait(w, 'lfc-card__fig') +
        '<div>' +
          '<p class="lfc-card__day">' + (e.j === 1 ? '1er' : e.j) + ' ' + MOIS[e.m - 1] + '</p>' +
          '<h2 class="lfc-card__name">' + esc(w.n) + '</h2>' +
          (w.a ? '<p class="lfc-card__years">' + esc(w.a) + '</p>' : '') +
          (tags ? '<ul class="lfc-card__tags">' + tags + '</ul>' : '') +
          (w.r ? '<p class="lfc-card__txt">' + esc(w.r) + '</p>' : '') +
          '<a class="lfc-card__cta" href="' + lien(e) + '">Lire son histoire →</a>' +
        '</div></article>';
    }
    out.innerHTML = [e].concat(e.s || []).map(carte).join('');
  }

  function chercher() {
    var j = parseInt(form.jour.value, 10), m = parseInt(form.mois.value, 10);
    if (!j || !m) return;
    afficher(find(m, j), m, j);
  }

  /* ---------- la femme du jour ---------- */

  function femmeDuJour() {
    var host = document.getElementById('today');
    if (!host) return;
    var now = new Date();
    var e = find(now.getMonth() + 1, now.getDate());
    if (!e) { host.closest('.lfc-today').hidden = true; return; }

    var meta = [e.a, e.p, e.c].filter(Boolean).join(' · ');
    host.innerHTML = portrait(e, 'lfc-today__fig') +
      '<div>' +
        '<p class="lfc-today__k">La femme du ' + (e.j === 1 ? '1er' : e.j) + ' ' + MOIS[e.m - 1] + '</p>' +
        '<h2 class="lfc-today__name">' + esc(e.n) + '</h2>' +
        (meta ? '<p class="lfc-today__meta">' + esc(meta) + '</p>' : '') +
        (e.r ? '<p class="lfc-today__txt">' + esc(e.r) + '</p>' : '') +
        (e.s && e.s.length ? '<p class="lfc-today__meta">Née' + (e.s.length > 1 ? 's' : '') +
          ' aussi ce jour-là : ' + e.s.map(function (w) { return esc(w.n); }).join(', ') + '</p>' : '') +
        '<a class="lfc-btn" href="' + lien(e) + '">Lire son histoire</a>' +
      '</div>';
  }

  /* ---------- calendrier par mois ---------- */

  function calendrier() {
    var tabs = document.getElementById('cal-tabs');
    var grid = document.getElementById('cal-grid');
    if (!tabs || !grid) return;

    MOIS.forEach(function (m, i) {
      var b = document.createElement('button');
      b.className = 'lfc-cal__tab';
      b.type = 'button';
      b.role = 'tab';
      b.textContent = m;
      b.setAttribute('aria-selected', 'false');
      b.addEventListener('click', function () { afficherMois(i + 1); });
      tabs.appendChild(b);
    });

    function afficherMois(m) {
      Array.prototype.forEach.call(tabs.children, function (b, i) {
        b.setAttribute('aria-selected', i + 1 === m ? 'true' : 'false');
      });
      var liste = DATA.filter(function (e) { return e.m === m; })
                      .sort(function (a, b) { return a.j - b.j; });
      grid.innerHTML = liste.map(function (e) {
        function tuile(w) {
          var fig = w.i
            ? '<figure class="lfc-day__fig"><img src="' + IMG + encodeURIComponent(w.i) +
              '" alt="" loading="lazy"><span class="lfc-day__num">' + pad(e.j) + '</span></figure>'
            : '<figure class="lfc-day__fig lfc-day__fig--none"><img src="' + LOGO +
              '" alt="" loading="lazy"><span class="lfc-day__num">' + pad(e.j) + '</span></figure>';
          return '<a class="lfc-day" href="' + lien(e) + '">' + fig +
                 '<p class="lfc-day__n">' + esc(w.n) + '</p>' +
                 (w.p ? '<p class="lfc-day__m">' + esc(w.p.split(' · ')[0]) + '</p>' : '') +
                 '</a>';
        }
        return [e].concat(e.s || []).map(tuile).join('');
      }).join('');
    }

    afficherMois(new Date().getMonth() + 1);
  }

  /* ---------- mosaïque du héro ---------- */

  function mosaique() {
    var host = document.getElementById('mosaic');
    if (!host) return;
    // les femmes des sacs : 6 affichées à la fois, les autres prennent leur place tour à tour
    var CHOIX = ["maryse-bastie", "george-sand", "annie-easley", "maria-callas", "frida-kahlo", "lin-zhao", "lucy-stanton", "maria-montessori", "billie-holiday", "claudette-colvin", "sadako-ogata", "camille-claudel", "olympe-de-gouges", "madeleine-pelletier"];
    var par = {}; DATA.forEach(function (e) { par[e.h] = e; });
    var pool = CHOIX.map(function (h) { return par[h]; }).filter(function (e) { return e && e.i; });
    var NB = Math.min(6, pool.length);
    function carte(e) {
      return '<img src="' + IMG + encodeURIComponent(e.i) + '" alt="' + esc(e.n) + '">';
    }
    var html = '';
    for (var i = 0; i < NB; i++) {
      html += '<a class="lfc-hero__bulle" style="--i:' + i + '" href="' + lien(pool[i]) + '" title="' + esc(pool[i].n) + '">' +
              carte(pool[i]) + '</a>';
    }
    host.innerHTML = html;
    if (pool.length <= NB || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var suivant = NB, slot = 0;
    setInterval(function () {
      var a = host.children[slot]; var e = pool[suivant % pool.length];
      var neuf = document.createElement('img'); neuf.src = IMG + encodeURIComponent(e.i); neuf.alt = e.n; neuf.className = 'entre';
      a.appendChild(neuf); a.href = lien(e); a.title = e.n;
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        neuf.classList.remove('entre');
        var ancien = a.querySelector('img:not(.entre)'); if (ancien && ancien !== neuf) { ancien.classList.add('sort'); setTimeout(function () { ancien.remove(); }, 900); }
      }); });
      suivant++; slot = (slot + 1) % NB;
    }, 2200);
  }

  /* ---------- chiffres calculés depuis le calendrier ---------- */

  // Variantes d'un même pays saisies différemment dans les fiches
  var PAYS_ALIAS = { 'Grande-Bretagne': 'Grande Bretagne', 'Royaume-Uni': 'Grande Bretagne',
    'Angleterre': 'Grande Bretagne', 'Irlande du Nord': 'Grande Bretagne', 'Pays-Bas': 'Pays-Bas' };

  function chiffresCalendrier() {
    var femmes = 0, pays = {}, metiers = {};
    (window.LFC || []).forEach(function (j) {
      [j].concat(j.s || []).forEach(function (f) {
        femmes++;
        (f.c || '').split(/\s*[·\/]\s*/).forEach(function (p) { if (p) pays[PAYS_ALIAS[p] || p] = 1; });
        (f.p || '').split(/\s*·\s*/).forEach(function (m) { if (m) metiers[m] = 1; });
      });
    });
    return { femmes: femmes, pays: Object.keys(pays).length, metiers: Object.keys(metiers).length };
  }

  /* ---------- compteurs animés ---------- */

  function compteurs() {
    var chiffres = chiffresCalendrier();
    document.querySelectorAll('[data-compte]').forEach(function (el) {
      var n = chiffres[el.dataset.compte];
      if (chiffres.femmes && n) el.dataset.to = n;
    });
    var els = document.querySelectorAll('.stat__n, .lfc-stat__n');
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.textContent = el.dataset.to; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, to = +el.dataset.to, t0 = null;
        requestAnimationFrame(function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 900, 1);
          el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        });
      });
    }, { threshold: .4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- menu mobile ---------- */

  function burger() {
    var b = document.getElementById('burger');
    var nav = document.querySelector('.hdr__nav');
    if (!b || !nav) return;
    b.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (ev) {
      if (ev.target.tagName === 'A') {
        nav.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- démarrage ---------- */

  if (HAS_FINDER) {
    remplirSelects();
    form.addEventListener('submit', function (ev) { ev.preventDefault(); chercher(); });
    form.jour.addEventListener('change', chercher);
    form.mois.addEventListener('change', function () { ajusterJours(); chercher(); });
  }

  femmeDuJour();
  calendrier();
  mosaique();
  compteurs();
  burger();

  // pré-remplissage par l'URL : ?j=9&m=1
  var p = new URLSearchParams(location.search);
  if (HAS_FINDER && p.get('j') && p.get('m')) {
    form.mois.value = p.get('m'); ajusterJours();
    form.jour.value = p.get('j'); chercher();
  }
})();
